import { CounterpartAccount } from "./CounterpartAccount";
export class Counterpart {
  id: number = null;
  name: string = null;
  document: string = null;
  status: boolean = true;
  isNewCounterpart: boolean = false;
  type: number = 1;
  selicAccount: string = null;
  cetipAccount: string = null;
  clearingAccount: string = null;
  brokerAccount: string = null;
  b3Account: string = null;
  counterpartAccounts: CounterpartAccount[] = null;
}
